/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-builder/index.ts to modify the generation of this file.

import { ComponentBuilder } from "@sitecore-jss/sitecore-jss-nextjs";

import * as FAQAttachments from "./components/customer-care/components/attachments/attachments";
import * as FaqHeader from "./components/customer-care/components/faq-header/faq-header";
import * as HighlightBlock from "./components/customer-care/components/highlight-block/highlight-block";
import * as FAQContent from "./components/customer-care/components/faq-content/FAQContent";
import * as MediaCTA from "./components/media-cta/media-cta";
import * as MediaGrid from "./components/media-cta/media-cta-grid";
import * as Hero from "./components/media-cta/media-cta";
import * as MediaCarousel from "./components/media-carousel/media-carousel";
import * as ImageList from "./components/customer-care/components/links-images/links-images";
import * as Accordion from "./components/accordion/accordion";
import * as AccordionSection from "./components/accordion/accordion-section";
import * as ContactUs from "./components/customer-care/components/get-in-touch/contact-us";
import * as GetInTouchContent from "./components/customer-care/components/get-in-touch/content";
import * as GetInTouchActionButtons from "./components/customer-care/components/get-in-touch/action-buttons";
import {
  SearchField,
  SearchResult,
} from "./components/customer-care/components/search";
import * as HelpTopicList from "./components/customer-care/components/help-topic-list/help-topic-list";
import * as PartialDesignDynamicPlaceholder from "./components/partial-design-component/partial-design-component";
import * as RichText from "./components/html-content/html-content";
import * as ContainerComponent from "./components/container-component/container-component";
import * as ImageHeader from "./components/image-header/image-header";
import * as ImageLink from "./components/image-link/image-link";
import * as DoubleImage from "./components/editorial/double-image/double-image";
import * as EditorialImage from "./components/editorial/image/editorial-image";
import * as EditorialParagraph from "./components/editorial/paragraph/editorial-paragraph";
import * as EditorialArticle from "./components/editorial/article/editorial-article";
import ArticleContainer from "./components/editorial/article/container/container";
import * as DenimContainer from "./components/denim-hub/container";
import * as FeatureCarouselVariants from "./components/denim-hub/feature-carousel";
import ProductGrid from "./components/editorial/product-grid/product-grid";
import CategoryShowcase from "./components/denim-hub/category-showcase";
import VideoPlayer from "./components/video-player/video-player";

export const components = new Map();

components.set("Media CTA", MediaCTA);
components.set("Media CTA Container", MediaGrid);
components.set("Hero", Hero);
components.set("FAQ Content", FAQContent);
components.set("FAQ Header", FaqHeader);
components.set("FAQ Attachments", FAQAttachments);
components.set("Highlight Block", HighlightBlock);
components.set("Hero Carousel", MediaCarousel);
components.set("FAQ Image Links", ImageList);
components.set("FAQ Image Link", ImageLink);
components.set("Accordion", Accordion);
components.set("FAQ Accordion Section", AccordionSection);
components.set("Accordion Section", AccordionSection);
components.set("Help Topics", HelpTopicList);
components.set(
  "PartialDesignDynamicPlaceholder",
  PartialDesignDynamicPlaceholder,
);
components.set("Search Bar", SearchField);
components.set("Search Results Heading", SearchResult);
components.set("Get In Touch", ContactUs);
components.set("Update Banner", HighlightBlock);
components.set("Rich Text", RichText);
components.set("Page Rich Text", RichText);
components.set("CCFaqContainer", ContainerComponent);
components.set("LegalContainer", ContainerComponent);
components.set("HomeContainer", ContainerComponent);
components.set("ComponentsHubContainer", ContainerComponent);
components.set("Image Header", ImageHeader);
components.set("Content Header", GetInTouchContent);
components.set("Get In Touch Buttons", GetInTouchActionButtons);
components.set("EditorialContainer", DenimContainer);
components.set("Double Image", DoubleImage);
components.set("Editorial Image", EditorialImage);
components.set("Editorial Paragraph", EditorialParagraph);
components.set("Article", EditorialArticle);
components.set("ArticleContainer", ArticleContainer);
components.set("ComponentsHubContainer", DenimContainer);
components.set("Feature Carousel", FeatureCarouselVariants);
components.set("Product Grid", ProductGrid);
components.set("Category Showcase", CategoryShowcase);
components.set("VideoClickToPlay", VideoPlayer);

export const componentBuilder = new ComponentBuilder({ components });

export const moduleFactory = componentBuilder.getModuleFactory();
